// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {img_url} from '../img_url';
import {Link} from '../../ui/link';
import {Settings_context} from '../../settings_ctx';
import styles from './br_footer.module.less';

const all_links = {
    sla: {href: '/legal/sla', title: 'EULA'},
    privacy: {href: '/legal/privacy', title: 'Privacy'},
    dmca: {href: '/legal/dmca', title: 'DMCA Policy'},
    sdk: {href: '/legal/sdk', title: 'BrightData Ethical SDK'},
    faq: {href: '/faq', title: 'FAQ'},
};

interface i_br_footer_props {
    logo?: string;
    links?: (keyof typeof all_links)[];
    links_domain?: string;
}
export const Br_footer = (props:i_br_footer_props)=>{
    const {links = ['sla', 'privacy', 'faq'], links_domain = '',
        logo = 'hola_logo_letters.svg'} = props;
    const {theme} = useContext(Settings_context);
    const render_links = links.map(id=>all_links[id]).map(link=>{
        if (links_domain)
            return {...link, href: `https://${links_domain}${link.href}`};
        return link;
    });
    return <div className={styles.br_footer}>
      <div className={styles.content_wrapper}>
        <div className={styles.content}>
          <img src={img_url(logo)} alt="logo" className="lazyload"/>
          <div className={styles.links}>
            {render_links.map(({href, title})=><Link key={href} href={href}>
              <p className={theme.p2}>{title}</p></Link>)}
          </div>
        </div>
      </div>
    </div>;
};
